// assets
import { countries } from 'src/assets/data';
//
// import { _mock } from './_mock';
// import { _tags } from './assets';

// ----------------------------------------------------------------------

export const ROOM_DETAILS_TABS = [
  { value: 'content', label: 'Room Content' },
  { value: 'reviews', label: 'Reviews' },
];

export const EMPLOYEE_STATUS_OPTIONS = [
  { value: '1', label: 'Active' },
  { value: '0', label: 'Rejected' },
];
export const STATUS_STATUS_OPTIONS = [
  { value: '1', label: 'Active' },
  { value: '0', label: 'Rejected' },
];


export const ROOM_LABEL_OPTIONS = [
  { value: '1', label: 'Excellent' },
  { value: '2', label: 'Very good' },
  { value: '3', label: 'Exceptional' },
];

export const ROOM_STATUS_OPTIONS = [
  {
    value: '1',
    label: 'Published',
  },
  {
    value: '0',
    label: 'Draft',
  },
];
